import { Validator } from '@vista-digital/validator';
import { defaultSingleFilterAssets, singleFilterAssetsValidator } from './assets';
import { defaultSingleFilterCdnOptions, singleFilterCdnOptionsValidator } from './cdn-options';
import { defaultSingleFilterConfig, singleFilterConfigValidator } from './config';
import { defaultSingleFilterDisplayText, singleFilterDisplayTextValidator } from './display-text';
export const singleFilterPropsValidator = Validator.object({
    filterId: Validator.nonEmptyString,
    config: singleFilterConfigValidator,
    displayText: singleFilterDisplayTextValidator,
    assets: singleFilterAssetsValidator,
    cdnOptions: singleFilterCdnOptionsValidator
});
export const defaultSingleFilterProps = {
    filterId: undefined,
    config: defaultSingleFilterConfig,
    displayText: defaultSingleFilterDisplayText,
    assets: defaultSingleFilterAssets,
    cdnOptions: defaultSingleFilterCdnOptions
};
//# sourceMappingURL=props.js.map